import {RetribuzioneLavoratore} from "@commons/mapping/DataTablesSchema";
import {PaginationReturnType} from "@components/dataTable/usePagination";
import React from "react";
import DTTitle from "../../../../components/dataTable/TableTitle";
import DTTable from "../../../../components/dataTable/Table";
import {LavoratoreRML} from "@commons/mapping/LavoratoreRML";
import Toggle from "../../../../components/Toggle";
import {formatDt, pagaOrariaFormat} from "@commons/utils/util";
import * as Buttons from "../../../../components/dataTable/buttons";
import Pagination from "../../../../components/dataTable/Pagination";
import {formatImporto} from "../../Lavoratori.retrib.page";
import {useLocation, useNavigate} from "react-router-dom";
import {alignMenu} from "@coreMenu/slice";
import {useAppDispatch} from "@hooks/redux-hooks/hooks";
import {setupContratto} from "@commons/core.slice";
import {useLazyGetLavoratoreQuery} from "@commons/features/lavoratore/lavoratore.api";
import {toastAsError} from "@utilities/toastAsError";

interface TabellaMensileRMLProps {
    title: string,
    datasource: RetribuzioneLavoratore | undefined,
    pagination: PaginationReturnType,
    showNominativo?: boolean,
    retribOraria: boolean,
    toggleRetribOraria: (v: boolean) => void,
    soloVariazioni?: boolean,
    toggleVariazioni?: (v: boolean) => void,
    URI: string | null,
    loadResource: (URI: string | null) => void,
    showSommaVoci?: boolean,
}

export const TabellaMensileRML: React.FC<TabellaMensileRMLProps> = ({
                                                                        title,
                                                                        datasource,
                                                                        pagination,
                                                                        showNominativo,
                                                                        retribOraria,
                                                                        toggleRetribOraria,
                                                                        soloVariazioni,
                                                                        toggleVariazioni,
                                                                        URI,
                                                                        loadResource,
                                                                        showSommaVoci,
                                                                    }) => {
    const {page, setPage, pageLength, setPageLength, search, setSearch} = pagination;
    const ComboHeader: React.FC<{ children: React.ReactNode }> = (props) => {
        return (<div className="flex flex-col items-start">
            <div className="w-fit">{props.children}</div>
            {(soloVariazioni === false || soloVariazioni === true) &&
                <Toggle auxState={soloVariazioni} onChange={(v) => toggleVariazioni!(v)} label="Solo variazioni"/>}
        </div>)
    }

    //https://stackoverflow.com/questions/70843123/react-router-v6-programmatically-redirect
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    //const {id} = useParams();
    const [getTrigger, result, promiseInfo] = useLazyGetLavoratoreQuery();
    const selezionaLavoratore = (idDip: number) => {

        getTrigger({idDip: idDip}, false).then((res) => {
            if (res && res.isSuccess) {
                //dispatch(setupLastContratto(res.data));
                dispatch(setupContratto(res.data));

                const newStato = `/lavoratori/retribuzione`;
                navigate(newStato);
                dispatch(alignMenu({newStato, oldStato: location.pathname}));

            } else if (res.isError) {
                if ('data' in res.error) {
                    // @ts-ignore
                    const message = res.error.data.message;
                    toastAsError(message);
                } else
                    toastAsError("Errore generico!");
            }
        });
    }

    return (<>
        <DTTitle id="elencoAziende" title={title} {...{currentPageLength: pageLength, setPageLength, currentSearch: search, setSearch}}/>

        <DTTable<LavoratoreRML> dtSchema={datasource}
                                header={<>
                                    {showNominativo &&
                                        [<th key="nominativo" scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            <ComboHeader>Nominitavo</ComboHeader>
                                        </th>,
                                            <th key="decorrenza" scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                Decorrenza
                                            </th>]}
                                    {!showNominativo &&
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                            <ComboHeader>Decorrenza</ComboHeader>
                                        </th>}

                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Qualifica
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Livello
                                    </th>
                                    {showSommaVoci &&
                                        <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-48">
                                            Somma voci non adeguata
                                        </th>}
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-48">
                                        <div className="flex flex-col items-start">
                                            <div className="w-fit">Retrib. adeguata</div>
                                            <Toggle auxState={retribOraria} onChange={(v) => toggleRetribOraria(v)} label={retribOraria ? 'Retrib. oraria' : 'Retrib. mensile'}/>
                                        </div>
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-48">
                                        Retrib. non adeguata
                                    </th>
                                    <th scope="col" className="py-3.5 w-14"/>
                                </>}

                                rows={({item, index, isMobile, currentRow, register}) => (
                                    <tr {...register(item.idDip + '_' + item.decorrenza!,
                                        index,
                                        item.URI === URI,
                                        (soloVariazioni === undefined || soloVariazioni || !item.diversaRispettoRilevazionePrec) ? 'text-gray-500' : 'text-red-500')}
                                    >
                                        {showNominativo &&
                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6">
                                                {item.nominativo}
                                            </td>
                                        }
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6">
                                            {formatDt(item.decorrenza, 'LLL yyyy')}
                                        </td>

                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6">
                                            {item.codQualifica}
                                        </td>
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6">
                                            {item.codLivello}
                                        </td>
                                        {showSommaVoci &&
                                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6">
                                                {formatImporto(LavoratoreRML.valorizzaElemento(retribOraria, 'sommaImportoVociNonAdeguata', item), (item.pagaOraria || retribOraria) ? pagaOrariaFormat : undefined)}
                                            </td>}
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6">
                                            {formatImporto(LavoratoreRML.valorizzaElemento(retribOraria, retribOraria ? 'retribuzioneNonAdeguata' : 'retribuzioneCompenso', item), (item.pagaOraria || retribOraria) ? pagaOrariaFormat : undefined)}
                                        </td>
                                        <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6">
                                            {formatImporto(LavoratoreRML.valorizzaElemento(retribOraria, 'retribuzioneNonAdeguata', item), (item.pagaOraria || retribOraria) ? pagaOrariaFormat : undefined)}
                                        </td>

                                        <td className="whitespace-nowrap py-2 text-sm font-medium">
                                            <Buttons.Visibility visible={isMobile || index === currentRow}>
                                                <Buttons.Edit onAction={() => loadResource(item.URI)}/>
                                                {showNominativo && <Buttons.GO onAction={() => selezionaLavoratore(item.idDip)}/>}
                                            </Buttons.Visibility>
                                        </td>
                                    </tr>)
                                }
        />
        <Pagination dataTables={datasource} currentPage={page} setPage={setPage} currentPageLength={pageLength}></Pagination></>);
}
export default TabellaMensileRML;